import React from 'react';
import { BottomSheet } from '@/components/ui/bottom-sheet';
import { CommitHistory } from './CommitHistory';

interface CommitHistorySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  devContainerId: string;
  projectId?: string;
  isStreaming?: boolean;
}

export function CommitHistorySheet({
  open,
  onOpenChange,
  devContainerId,
  projectId,
  isStreaming = false,
}: CommitHistorySheetProps): JSX.Element {
  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title="Version History">
      <CommitHistory
        devContainerId={devContainerId}
        projectId={projectId}
        isStreaming={isStreaming}
        hideHeader={true}
        className="h-full"
      />
    </BottomSheet>
  );
}
